import { render } from "./UserInfo.vue?vue&type=template&id=20613457&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"

import "./UserInfo.vue?vue&type=style&index=0&id=20613457&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20613457"],['__file',"src/components/list-items/UserInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20613457"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20613457', __exports__)) {
    api.reload('20613457', __exports__)
  }
  
  module.hot.accept("./UserInfo.vue?vue&type=template&id=20613457&scoped=true", () => {
    api.rerender('20613457', render)
  })

}


export default __exports__